import { useEffect } from "react";
import { AuthService } from "../../services/auth.service";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import useAppDispatch from "../../hooks/useAppDispatch";
import { handleError } from "../../helper/errorHandler";
import { login } from "../../store/userProfile/userProfileSlice";
import "./AppleSignInButton.scss";

declare global {
  interface Window {
    AppleID: {
      auth: {
        init: (options: {
          clientId: string;
          scope: string;
          redirectURI: string;
          state?: string;
          nonce?: string;
          usePopup?: boolean;
        }) => void;
        signIn: () => Promise<{
          authorization: {
            code: string;
            id_token: string;
            state?: string;
            user?: {
              email?: string;
              name?: {
                firstName?: string;
                lastName?: string;
              };
            };
          };
          user?: {
            email?: string;
            name?: {
              firstName?: string;
              lastName?: string;
            };
          };
        }>;
      };
    };
  }
}

const AppleSignInButton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    window.AppleID.auth.init({
      clientId: "gr.clubpass",
      scope: "name email",
      redirectURI: "https://clubpass.gr",
      usePopup: true,
    });
  }, []);

  const handleClick = async () => {
    try {
      const response = await window.AppleID.auth.signIn();

      if (!response) return;

      const idToken = response.authorization.id_token;
      const user = response?.authorization?.user;
      const requestBody = {
        token: idToken,
        firstName: user?.name?.firstName || null,
        lastName: user?.name?.lastName || null,
      };

      const responseAuth = await AuthService.loginApple(requestBody);

      if (responseAuth?.status === 200) {
        const res = await AuthService.getCurrentUser();

        if (res && res.status === 200) {
          dispatch(login(res.data));
          navigate("/your-location");
        } else {
          handleError(new Error("SOMETHING_WENT_WRONG"), dispatch, t);
        }
      } else {
        handleError(new Error("SOMETHING_WENT_WRONG"), dispatch, t);
      }
    } catch (err) {
      handleError(err, dispatch, t);
    }
  };

  return <div id="appleid-signin" onClick={handleClick} className="apple-signin-button"></div>;
};

export default AppleSignInButton;
